import { useParams } from 'react-router-dom';

import { AppCommunityPage } from '~/components/pages/AppCommunityPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppCommunityRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId} hasAside>
      <AppCommunityPage appId={appId} />
    </DashboardTemplate>
  );
};
